import {AsyncPage, Empty} from 'Core/models/Async';
import {createAction} from 'Shared/utilities/actionCreator';
import {Page} from 'Core/models/Page';
import {pipe} from 'fp-ts/lib/pipeable';
import {fold as foldOption, fromNullable} from 'fp-ts/lib/Option';
import {constant} from 'fp-ts/lib/function';
import {PageFetchAction} from 'Shared/utilities/sagaApiGenerators';
import {Disposition} from 'GenericTexting/models/Disposition';

export enum DispositionActionType {
  SEARCH_DISPOSITIONS = 'disposition/SEARCH_DISPOSITIONS',
  CHANGE_DISPOSITIONS = 'disposition/CHANGE_DISPOSITIONS',
  CHANGE_DISPOSITIONS_FILTER = 'disposition/CHANGE_DISPOSITIONS_FILTER',
}

export const DefaultClientFilters: DispositionFilters = {
  pageSize: 0,
  phoneNumber: '',
  shortCode: '',
  messageId: '',
  status: '',
};

export type DispositionFilters = {
  pageSize?: number;
  phoneNumber: string;
  shortCode: string;
  messageId: string;
  status: string;
};

export const searchDispositions = (pageOption?: Page<Disposition>, filter?: DispositionFilters) => {
  const payload = pipe(
    fromNullable(pageOption),
    foldOption(constant(PageFetchAction.Initial({filter})), page =>
      PageFetchAction.Additional({existingPage: page, filter})
    )
  );
  return createAction(DispositionActionType.SEARCH_DISPOSITIONS, payload);
};

export const changeDispositions = (dispositionReports: AsyncPage<Page<Disposition>>) =>
  createAction(DispositionActionType.CHANGE_DISPOSITIONS, dispositionReports);

export const changeDispositionsFilters = (filters: DispositionFilters) =>
  createAction(DispositionActionType.CHANGE_DISPOSITIONS_FILTER, {filters});

type DispositionState = {
  dispositionPage: AsyncPage<Page<Disposition>>;
  filter: DispositionFilters;
};

export const DEFAULT_STATE: DispositionState = {
  dispositionPage: new Empty(),
  filter: DefaultClientFilters,
};

type DispositionAction =
  | ReturnType<typeof searchDispositions>
  | ReturnType<typeof changeDispositions>
  | ReturnType<typeof changeDispositionsFilters>;

export default (state: DispositionState = DEFAULT_STATE, action: DispositionAction): DispositionState => {
  switch (action.type) {
    case DispositionActionType.CHANGE_DISPOSITIONS:
      return {
        ...state,
        dispositionPage: action.payload,
      };
    case DispositionActionType.CHANGE_DISPOSITIONS_FILTER:
      return {
        ...state,
        filter: action.payload.filters,
      };
    default:
      return state;
  }
};
